/**
 * The countries whose CL733 (postcode availability) indicator is `C` - names of localities only.
 * Condition C3034 makes the postcode optional for these and mandatory for every other country.
 *
 * Copied from the ICS2 HTI code lists v3.20 (2026-06-30, `7. ICS2-HTI-CL`, CL733). The backend serves
 * the same list, but the ENS validators are plain schemas with no access to the store, so the
 * values are held here. Compare against the code list when a new version of the specification
 * comes out.
 */
// prettier-ignore
export const POSTCODE_OPTIONAL_COUNTRIES: readonly string[] = [
    'AE', 'AG', 'AO', 'BF', 'BI', 'BJ', 'BO', 'BW', 'BZ', 'CD',
    'CF', 'CG', 'CI', 'CM', 'DJ', 'DM', 'ER', 'ET', 'GA', 'GD',
    'GH', 'GM', 'GQ', 'GY', 'HK', 'JM', 'KI', 'KM', 'KN', 'KP',
    'LY', 'ML', 'MM', 'MR', 'MW', 'NR', 'PA', 'QA', 'RW', 'SB',
    'SC', 'SO', 'SR', 'SS', 'ST', 'SY', 'TD', 'TG', 'TL', 'TO',
    'TV', 'UG', 'VU', 'YE', 'ZM', 'ZW',
];

export const isPostcodeOptional = (country: string): boolean => POSTCODE_OPTIONAL_COUNTRIES.includes(country);
